/**
 * LanguageSplash — full-screen "switching language" cover.
 *
 * A language change ends in a hard reload (the i18next resources
 * behind the legacy screens load on init only), and in the dashboard
 * it is preceded by a PATCH to the backend. Without a cover the page
 * just freezes for the round trip and then blanks — this component is
 * what the user sees instead: the animated wordmark and a progress bar,
 * mounted immediately on click and kept until the reload takes over.
 *
 * Two surfaces:
 *   - default: opaque, painted in the dashboard background, so the
 *     upcoming reload cross-fades without a colour swap (public pages).
 *   - overlay: translucent with a backdrop blur, so the dashboard
 *     stays recognisable underneath while it waits (signed-in shell).
 */
import { BrandLogo } from '../BrandLogo';
import './LanguageSplash.css';

const LanguageSplash = ({ overlay = false }) => (
  <div
    className={`qhs-lang-splash${overlay ? ' qhs-lang-splash--overlay' : ''}`}
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div className="qhs-lang-splash__content">
      <BrandLogo
        variant="wordmark"
        tone="inherit"
        size={240}
        animated
        className="qhs-lang-splash__logo"
      />
      <div className="qhs-lang-splash__progress" aria-hidden="true">
        <span className="qhs-lang-splash__progress-bar" />
      </div>
    </div>
  </div>
);

export default LanguageSplash;
